
import HomeStartUp from '../pages/HomeStartUp'
import NotFound from '../pages/elements/404'
// import Disclaimer from '../pages/Disclaimer'
// import Privacy from '../pages/Privacy'
// import Terms from '../pages/Terms'

export const routes = [
    {
        path:'/',
        name: 'HomeStartUp',
        component: HomeStartUp
    },
    // {
    //     path:'/disclaimer',
    //     name: 'Disclaimer',
    //     component: Disclaimer
    // },
    // {
    //     path:'/terms',
    //     name: 'Terms & Conditions',
    //     component: Terms
    // },
    // {
    //     path:'/privacy',
    //     name: 'Privacy Policy',
    //     component: Privacy
    // },
    {
        path:'*',
        name: 'NotFound',
        component: NotFound
    },
];